export async function checkAuthStatus() {
  try {
    const response = await fetch("/api/_allauth/browser/v1/auth/session", {
      method: "GET",
      credentials: "include",
    });

    if (response.status === 200) {
      const data = await response.json();
      let user = {
        isAuthenticated: data.meta.is_authenticated,
        user: data.data.user,
      };
      // Fetch stats if authenticated
      if (user.isAuthenticated) {
        try {
          const statsRes = await fetch("/api/v1/student/stats/", {
            method: "GET",
            credentials: "include",
          });
          if (statsRes.status === 200) {
            const statsData = await statsRes.json();
            console.log("Student stats:", statsData);
            user.stats = statsData;
          } else {
            user.stats = null;
          }
        } catch (err) {
          console.error("Error fetching student stats:", err);
          user.stats = null;
        }
        // Fetch video lessons endpoints
        try {
          const allRes = await fetch("/api/v1/student/video-lessons/all/", {
            method: "GET",
            credentials: "include",
          });
          user.videoLessonsAll = allRes.status === 200 ? await allRes.json() : [];
          console.log("videoLessonsAll:", user.videoLessonsAll);
        } catch (err) {
          console.error("Error fetching videoLessonsAll:", err);
          user.videoLessonsAll = [];
        }
        try {
          const completedRes = await fetch("/api/v1/student/video-lessons/completed/", {
            method: "GET",
            credentials: "include",
          });
          user.videoLessonsCompleted = completedRes.status === 200 ? await completedRes.json() : [];
          console.log("videoLessonsCompleted:", user.videoLessonsCompleted);
        } catch (err) {
          console.error("Error fetching videoLessonsCompleted:", err);
          user.videoLessonsCompleted = [];
        }
        try {
          const startedRes = await fetch("/api/v1/student/video-lessons/started/", {
            method: "GET",
            credentials: "include",
          });
          user.videoLessonsStarted = startedRes.status === 200 ? await startedRes.json() : [];
          console.log("videoLessonsStarted:", user.videoLessonsStarted);
        } catch (err) {
          console.error("Error fetching videoLessonsStarted:", err);
          user.videoLessonsStarted = [];
        }
      }
      return user;
    }

    if (response.status === 401 || response.status === 410) {
      return { isAuthenticated: false };
    }
  } catch (error) {
    console.error("Помилка при перевірці стану авторизації:", error);
    return { isAuthenticated: false };
  }
}
